<template>
  <v-container>
    <div
      v-if="!Loading">
      <v-row justify="center">
        <v-col md="12">
          <v-container>
            <v-card>
              <v-toolbar
                color="primary"
                dark>
                <v-toolbar-title>
                  <v-icon>search</v-icon>生徒を探す
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <span class="text--primary">生徒の検索を行います。</span>
              </v-card-text>
              <v-divider></v-divider>
              <StudentsSearchBox
                v-model="conditions"
                @target="target"
              />
              <div v-if="this.students.length === 0">
                <v-divider></v-divider>
                <v-container>
                  該当生徒は見つかりませんでした。
                </v-container>
              </div>
            </v-card>
          </v-container>
          <v-container>
          <v-row>
            <v-col
              v-for="student in this.students"
              :key="student.id"
              md="4"
              sm="6"
              cols="12"
            >
              <StudentsList
                :student="student"
                @request="request"
                @cancel="cancel"
              />
            </v-col>
          </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-dialog
        v-model="requestDialog"
        max-width="420"
        persistent
      >
        <v-card>
          <v-row justify="center">
            <v-card-title class="headline">
              <span>リクエストを送信しました。</span>
            </v-card-title>
            <span class="text--primary">リクエストが承認されると、生徒一覧に反映されます。</span>
          </v-row>
          <v-row justify="center">
            <v-card-actions>
              <v-btn
                outlined
                @click="requestDialog=false"
              >閉じる
              </v-btn>
             </v-card-actions>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="cancelDialog"
        width="400"
        persistent
      >
        <v-card>
          <v-row justify="center">
            <v-card-title class="headline">
              <span>リクエストを取り消しました。</span>
            </v-card-title>
          </v-row>
          <v-row justify="center">
            <v-card-actions>
              <v-btn
                outlined
                @click="cancelDialog=false"
                >閉じる
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
    <div
      v-else>
      <Loading/>
    </div>
  </v-container>
</template>

<script>
import { StudentRepository } from '@/repository/StudentRepository.js'
import { RequestRepository } from '@/repository/RequestRepository.js'
import { firestore } from '@/repository/client/firestore.js'
import Loading from '@/components/organisms/Loading.vue'
import StudentsList from '@/components/organisms/teacher/StudentsList.vue'
import StudentsSearchBox from '@/components/organisms/teacher/StudentsSearchBox.vue'

export default {
  name:'SearchStudents',
  data() {
    return {
      students: [],
      displayStudents: [],
      teacher: this.$store.getters.teacher,
      requestDialog: false,
      cancelDialog: false,
      Loading: true,
      conditions: {
        schools: ["elementary_school", "junior_high_school", "high_school"],
        prefecture: "",
        availableDays: ["月", "火", "水", "木", "金", "土", "日"]
      },
    }
  },
  components: {
    'StudentsList': StudentsList,
    'StudentsSearchBox': StudentsSearchBox,
    'Loading': Loading,
  },
  methods:{
    async request(student) {
      await this.requestRepo.create(student.parentId, this.teacher.uuid, student.id)
      this.requestDialog = true
    },
    async cancel(student) {
      const inRequests = await this.requestRepo.listOfInRequest(student.parentId)
      const requestByTeacher = inRequests.filterByStudentId(student.id).findBySenderId(this.teacher.uuid)
      await this.requestRepo.delete(requestByTeacher)
      this.cancelDialog = true
    },
    target() {
      this.students = this.displayStudents.filter(student => student.filterByConditions(this.conditions))
    }
  },
  created: async function() {
    this.requestRepo = new RequestRepository(firestore)
    const studentRepo = new StudentRepository(firestore)
    const allStudents =  await studentRepo.query(100)
    this.displayStudents = allStudents.filter(student => !this.teacher.studentIds.includes(student.id))
    this.students = this.displayStudents
    this.Loading = false
  }
}
</script>

